import { useState, useEffect } from "react";
import { Vector3 } from "three";
import { useFrame } from "@react-three/fiber";
import { useSpring } from "react-spring";
import useStore from "../modules/useStore";

export default function Intro({ start, set }) {
  const { target, onProjects } = useStore(
    ({ currentProject: target, onProjects }) => ({
      target,
      onProjects,
    })
  );
  const [vec] = useState(() => new Vector3());
  const { x, y, z } = useSpring({
    from: { x: 0 },
    x: target * 8,
    y: onProjects ? 0.25 : 5,
    z: onProjects ? 10 : 25,
    // z: onProjects ? 14 : 20,
    config: {
      mass: 4,
      damping: 0.9,
      tension: 120,
      friction: 60,
    },
  });
  useEffect(() => setTimeout(() => set(true), 500), [set]);

  return useFrame((state) => {
    if (start) {
      state.camera.position.lerp(
        vec.set(
          (state.mouse?.x || window.innerWidth) * 5 + x.get(),
          y.get() + state.mouse.y,
          z.get() + Math.abs(state.mouse.x) * 4
        ),
        0.05
      );
      state.camera.lookAt(x.get(), y.get(), 0);
    }
  });
}
